import { Image } from '@acme/assets';
import type { IRouteConfig } from '@acme/foundation';
import { AppRoutes } from '@app/router';
import { Alert, Button } from 'flowbite-react';
import { Link } from 'react-router-dom';

const WelcomePage = () => {
  return (
    <div className="flex flex-col gap-6 ">
      <div className="bg-gray-100 rounded-2xl p-4 flex flex-col items-center gap-4">
        <div className="w-40 h-40 flex items-center justify-center">
          <Image
            name="acces"
            width="100%"
            height="100%"
            alt="Вход с КЭП"
            className="object-contain"
          />
        </div>

        <Link
          to={(AppRoutes.auth as IRouteConfig).ecp.path as string}
          className="w-80"
        >
          <Button color="primary" className="w-full">
            Войти с КЭП
          </Button>
        </Link>
      </div>

      <Alert color="info" className="bg-gray-50">
        <p className="text-sm text-gray-800">
          Для доступа к платформе используется квалифицированная электронная
          подпись (КЭП). Вход возможен только для юридических лиц и
          уполномоченных сотрудников.
        </p>
      </Alert>
    </div>
  );
};

export { WelcomePage };
